import React from 'react'
import KotakPaymentPage from './Payment'

/**
 * Kotak never uses the strip checkout UI. Any /checkout hit renders the same
 * payment flow (recording modal → QRIS) so amount is always stamped.
 */
const KotakCheckoutRedirect: React.FC = () => <KotakPaymentPage />

export default KotakCheckoutRedirect
